import { EntityRatingCommentCount, Rating } from '@medprev-web-app/api-graphql-client';

import { SearchApiRating, SearchApiRatingComment } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { RatingComment } from '@/types';

export function mapSearchApiRating(rating: SearchApiRating | null): Rating {
  return {
    fiveStars: {
      average: rating?.average ?? 0,
      count: rating?.ratingsCount ?? 0,
      tiers: {
        one: rating?.tiers?.one ?? 0,
        two: rating?.tiers?.two ?? 0,
        three: rating?.tiers?.three ?? 0,
        four: rating?.tiers?.four ?? 0,
        five: rating?.tiers?.five ?? 0,
      },
    },
  };
}

export function mapSearchApiCommentCount(rating: SearchApiRating | null): EntityRatingCommentCount {
  return { total: rating?.commentsCount ?? 0, comments: [] };
}

export function mapSearchApiRatingComment(comment: SearchApiRatingComment): RatingComment {
  return {
    id: comment.id,
    authorName: comment.authorName,
    comment: comment.comment,
    createdAt: comment.createdAt,
    ratingValue: comment.ratingValue,
    responseComment: comment.responseComment
      ? {
          id: comment.responseComment.id,
          comment: comment.responseComment.comment,
          createdAt: comment.responseComment.createdAt,
        }
      : undefined,
  };
}
